var $ = require("jquery");
var Popover = require("./popover");

function Share() {
    let BsPopover = null;
    const popoverButtonSelector = "[data-share-action='copy-url']";
    const shareThisModuleSelector = ".ws-section--share-this";
    const $shareThisModule = $(shareThisModuleSelector);
    const $lazyShareThisButtons = $(".st-custom-button[data-network]").filter(function () {
        return $(this).parents(shareThisModuleSelector).length === 0;
    });

    const $lazyPopoverButtons = $(popoverButtonSelector).filter(function () {
        return $(this).parents(shareThisModuleSelector).length === 0;
    });

    function initShareThis() {
        if ($shareThisModule.length > 0) {
            if (typeof window.__sharethis__ === "undefined") {
                $.getScript("https://platform-api.sharethis.com/js/sharethis.js#property=5a1ebf41c87cd900112f818b&product=custom-share-buttons");
            } else {
                window.__sharethis__.initialize();
                window.__sharethis__.href = document.location.href;
            }
        }
    }

    // Defer intialization of ShareThis until user clicks on share button
    if ($lazyShareThisButtons.length > 0) {
        $lazyShareThisButtons.one("click", function() {
            if (typeof window.__sharethis__ === "undefined") {
                var $shareButton = $(this);

                var shareThisLoadCheck = setInterval(function() {
                    if ((typeof window.__sharethis__ !== "undefined") && (typeof window.__sharethis__.config !== "undefined")) {
                        if (window.__sharethis__.is_ie) {
                            setTimeout(function() { $shareButton.click(); }, 100); // IE needs a little extra help
                        }
                        else {
                            $shareButton.click();
                        }
                        clearInterval(shareThisLoadCheck);
                    }
                }, 20);

                $.getScript("https://platform-api.sharethis.com/js/sharethis.js#property=5a1ebf41c87cd900112f818b&product=custom-share-buttons");
            }
            else {
                window.__sharethis__.initialize();
                window.__sharethis__.href = document.location.href;
            }
        });
    }

    $(".ws-share__button").on({
        "touchstart": addActiveClass
    });

    function addActiveClass() {
        $(this).addClass("ws-can-touch");
    };

    $($lazyPopoverButtons).on("click", function (event) {
        var $target = $(event.currentTarget);

        if (BsPopover) {
            onPopoverClick($target);
        } else {
            import(/* webpackChunkName: "bspopover" */ "bootstrap/js/dist/popover").then(({ default: bsPopover }) => {
                BsPopover = bsPopover;
                onPopoverClick($target);
            });
        }
    });

    function onPopoverClick($target) {
        copyToClipboard(document.location.href);
        $target.focus();
        Popover.notificationPopover($target);
    }

    // method taken from https://stackoverflow.com/a/33928558
    function copyToClipboard(text) {
        if (window.clipboardData && window.clipboardData.setData) {
            // IE specific code path to prevent textarea being shown while dialog is visible.
            return clipboardData.setData("Text", text);
        } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = text;
            textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
            textarea.contentEditable = true;
            textarea.readOnly = true;
            document.body.appendChild(textarea);
            // ios specific code based on this solution: https://stackoverflow.com/a/41267511
            if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
                var range = document.createRange();
                range.selectNodeContents(textarea);
                var sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
                textarea.setSelectionRange(0, 999);
            } else {
                textarea.select();
            }
            try {
                return document.execCommand("copy");  // Security exception may be thrown by some browsers.
            } catch (ex) {
                if (console && console.warn) {
                    console.warn("Copy to clipboard failed.", ex);
                }
                return false;
            } finally {
                document.body.removeChild(textarea);
            }
        }
    };

    $(document).on("lazyloaded", shareThisModuleSelector, function(event) {
        if (event.currentTarget === event.target) {
            initShareThis();
        }
    });
}

$(function () {
    Share();
});

exports.Share = Share;